const actions = {
  SET_STATE: 'registerVirtualuser/SET_STATE',
  UPLOAD_AVATAR: 'registerVirtualuser/UPLOAD_AVATAR',
  COMPLETE_REGISTRATION: 'registerVirtualuser/COMPLETE_REGISTRATION',
  VALIDATE_EMAIL: 'registerVirtualuser/VALIDATE_EMAIL',
  VALIDATE_PHONE: 'registerVirtualuser/VALIDATE_PHONE',
}

export default actions
